var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'PartnerMarketingEventList'
      }
    }
  }, [_vm._v("點數/商品兌換活動")]), _vm.fromEventPage && _vm.parentEvent ? _c('b-breadcrumb-item', {
    on: {
      "click": _vm.backToEventList
    }
  }, [_vm._v(_vm._s(_vm.parentEvent.name))]) : _vm._e(), _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: _vm.fromEventPage ? 'PartnerMarketingPlanListByEvent' : 'PartnerMarketingPlanList',
        params: _vm.fromEventPage ? {
          partnerMarketingEventId: _vm.$route.params.partnerMarketingEventId
        } : {}
      }
    }
  }, [_vm._v(" 兌換活動方案 ")]), _vm.partnerMarketingPlan ? _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: _vm.fromEventPage ? 'PartnerMarketingPlanViewByEvent' : 'PartnerMarketingPlanView',
        params: _vm.fromEventPage ? {
          partnerMarketingEventId: _vm.$route.params.partnerMarketingEventId,
          partnerMarketingPlanId: _vm.planId
        } : {
          partnerMarketingPlanId: _vm.planId
        }
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.partnerMarketingPlan.name) + " ")]) : _vm._e(), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("序號管理")])], 1)], 1)])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2 justify-content-between"
  }, [_c('h4', {
    staticClass: "col-12 col-xl-6 mb-2 mb-xl-0 font-weight-bold"
  }, [_vm._v(" 序號管理 ")]), _c('b-input-group', {
    staticClass: "col-12 col-xl-6 mb-2"
  }, [!_vm.isDeleteMode ? [_c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.handleExport
    }
  }, [_c('i', {
    staticClass: "mdi mdi-download"
  }), _vm._v("匯出")]), _vm.checkPermission([_vm.consts.PARTNER_MARKETING_CODE_DELETE]) ? _c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.enterDeleteMode
    }
  }, [_c('i', {
    staticClass: "mdi mdi-delete"
  }), _vm._v("批次刪除")]) : _vm._e(), _vm.checkPermission([_vm.consts.PARTNER_MARKETING_CODE_CREATE]) ? _c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.showUploadModal
    }
  }, [_c('i', {
    staticClass: "mdi mdi-upload"
  }), _vm._v("批次上傳")]) : _vm._e()] : [_c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": _vm.cancelDeleteMode
    }
  }, [_vm._v("取消")]), _c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "variant": "danger",
      "disabled": _vm.selectedItems.length === 0
    },
    on: {
      "click": _vm.confirmBatchDelete
    }
  }, [_c('i', {
    staticClass: "mdi mdi-delete"
  }), _vm._v("刪除序號")])], !_vm.isDeleteMode ? _c('b-form-input', {
    attrs: {
      "placeholder": "搜尋序號"
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handlePageReset.apply(null, arguments);
      }
    },
    model: {
      value: _vm.query.keyword,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "keyword", $$v);
      },
      expression: "query.keyword"
    }
  }) : _vm._e(), !_vm.isDeleteMode ? _c('b-input-group-append', [_c('b-button', {
    on: {
      "click": _vm.handlePageReset
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])], 1) : _vm._e()], 2), _c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_c('span', [_vm._v("方案名稱：" + _vm._s(_vm.partnerMarketingPlan ? _vm.partnerMarketingPlan.name : ''))]), _c('br'), _c('span', [_vm._v("序號總數：" + _vm._s(_vm.serialStats.total || 0))]), _c('br'), _c('span', [_vm._v("未指派數目：" + _vm._s(_vm.serialStats.not_belong_count || 0))]), _c('br'), _c('span', [_vm._v("已指派數目：" + _vm._s(_vm.serialStats.belong_count || 0))]), _c('br')])], 1), _c('b-card-text', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-overlay', {
    attrs: {
      "rounded": "sm"
    }
  }, [_c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "responsive": "",
      "items": _vm.serials,
      "fields": _vm.displayFields,
      "busy": _vm.isLoading,
      "show-empty": ""
    },
    on: {
      "row-clicked": _vm.rowClicked
    },
    scopedSlots: _vm._u([{
      key: "table-busy",
      fn: function fn() {
        return [_c('div', {
          staticClass: "text-center my-2"
        }, [_c('b-spinner', {
          staticClass: "align-middle"
        })], 1)];
      },
      proxy: true
    }, {
      key: "cell(selected)",
      fn: function fn(data) {
        return [!data.item.redeem_at ? _c('b-form-checkbox', {
          on: {
            "change": _vm.updateSelectedItems
          },
          model: {
            value: data.item.selected,
            callback: function callback($$v) {
              _vm.$set(data.item, "selected", $$v);
            },
            expression: "data.item.selected"
          }
        }) : _vm._e()];
      }
    }, {
      key: "head(selected)",
      fn: function fn() {
        return [_c('b-form-checkbox', {
          on: {
            "change": _vm.toggleSelectAll
          },
          model: {
            value: _vm.selectAll,
            callback: function callback($$v) {
              _vm.selectAll = $$v;
            },
            expression: "selectAll"
          }
        })];
      },
      proxy: true
    }, {
      key: "cell(belong_at)",
      fn: function fn(data) {
        return [_vm._v(" " + _vm._s(_vm.formatDate(data.item.belong_at)) + " ")];
      }
    }, {
      key: "cell(is_enabled)",
      fn: function fn(data) {
        return [_c('b-badge', {
          attrs: {
            "variant": data.item.is_enabled ? 'success' : 'danger'
          }
        }, [_vm._v(" " + _vm._s(data.item.is_enabled ? '啟用' : '停用') + " ")])];
      }
    }, {
      key: "cell(status)",
      fn: function fn(data) {
        return [_c('b-badge', {
          attrs: {
            "variant": _vm.getStatusVariant(data.item)
          }
        }, [_vm._v(" " + _vm._s(_vm.getStatusText(data.item)) + " ")])];
      }
    }, {
      key: "cell(actions)",
      fn: function fn(data) {
        return [_c('div', {
          staticClass: "text-center"
        }, [_vm.checkPermission([_vm.consts.PARTNER_MARKETING_CODE_MODIFY]) ? _c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "variant": data.item.is_enabled ? 'warning' : 'success',
            "size": "sm"
          },
          on: {
            "click": function click($event) {
              return _vm.toggleCodeStatus(data.item);
            }
          }
        }, [_vm._v(" " + _vm._s(data.item.is_enabled ? '停用' : '啟用') + " ")]) : _vm._e(), _vm.checkPermission([_vm.consts.PARTNER_MARKETING_CODE_DELETE]) ? _c('b-button', {
          attrs: {
            "variant": "danger",
            "size": "sm",
            "disabled": !_vm.canDelete(data.item)
          },
          on: {
            "click": function click($event) {
              return _vm.deleteCode(data.item);
            }
          }
        }, [_vm._v(" 刪除 ")]) : _vm._e()], 1)];
      }
    }])
  })], 1)], 1)]), _c('CustomPagination', {
    attrs: {
      "currentPage": _vm.pagination.page,
      "totalRows": _vm.pagination.total,
      "perPage": _vm.pagination.per_page
    },
    on: {
      "page-change": _vm.handlePageChange,
      "per-page-change": _vm.handlePerPageChange
    }
  })], 1)], 1)], 1)], 1)]), _c('b-modal', {
    attrs: {
      "id": "modal-upload",
      "title": "批次上傳"
    },
    on: {
      "ok": _vm.uploadSerials
    }
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoadingUpload
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("請上傳序號 Excel 檔案")]), _c('ul', {
    staticClass: "text-danger"
  }, [_c('li', [_vm._v("第一欄位為序號，不得留空")]), _c('li', [_vm._v("第二欄位為廠編，不得留空")]), _c('li', [_vm._v("每行一個序號")]), _c('li', [_vm._v("序號長度不能超過 30 個字元")])]), _c('b-form-file', {
    attrs: {
      "plain": "",
      "placeholder": "尚未選擇檔案",
      "browse-text": "瀏覽"
    },
    model: {
      value: _vm.uploadFile,
      callback: function callback($$v) {
        _vm.uploadFile = $$v;
      },
      expression: "uploadFile"
    }
  }), _c('b-button', {
    staticClass: "mt-2",
    attrs: {
      "size": "sm",
      "variant": "outline-primary",
      "href": "/excel/marketing_codes.xlsx"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text"
  }), _vm._v("下載範例檔案")])], 1)])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }